import { designTr } from './design.tr.js';
import { familyTr } from './family.tr.js';
import { foodTr } from './food.tr.js';
import { kamersTr } from './kamers.tr.js';
import { kioskBoardTr } from './kioskBoard.tr.js';
import { kioskPrivacyTr } from './kioskPrivacy.tr.js';
import { kioskMoveTr } from './kioskMove.tr.js';
import { readAloudTr } from './readAloud.tr.js';
import { todoTr } from './todo.tr.js';
import { kioskWeatherTr } from './kioskWeather.tr.js';
import { kioskTimerTr } from './kioskTimer.tr.js';
import { hallwayTr } from './hallway.tr.js';
import { kioskRemindersTr } from './reminders.tr.js';
// Turks (tr-TR): teksten van het bord (zelfde vorm als nl.ts). Wat ontbreekt valt terug op het
// Nederlands. Weekdagen en maanden komen uit Intl (tr-TR: Pazartesi, Eylül); daarom staan ze hier
// niet. Sleutels die in nl.ts zelf staan (common, kiosk, web) horen hier; de rest in het eigen
// domeinbestand (design.tr.ts, food.tr.ts, …).
export const tr = {
    design: designTr,
    food: foodTr,
    family: familyTr,
    kamers: kamersTr,
    reminders: kioskRemindersTr,
    weather: kioskWeatherTr,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerTr,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.tr.ts).
    hallway: hallwayTr,
    // 0036: melding "Dit bord stopt op ..." (golf 4).
    privacy: kioskPrivacyTr,
    move: kioskMoveTr,
    readAloud: readAloudTr,
    // 0058: to-do's onder de taken van een lid (todo.tr.ts).
    todo: todoTr,
    common: {
        adjustBoard: 'Düzenle',
        refreshBoard: 'Yenile',
        create: 'Yeni oluştur',
        agendaBoard: 'Takvim',
        today: 'Bugün',
        tomorrow: 'Yarın',
        now: 'Şimdi',
        later: 'Sonra',
        done: 'Bitti',
        cancel: 'Vazgeç',
        confirm: 'Onayla',
        back: 'Geri',
        close: 'Kapat',
    },
    kiosk: {
        ...kioskBoardTr,
        // 0035: gepauzeerd door AMUMIN Beheer (golf 4).
        paused: 'Sadece görüntüleme',
        pausedHint: 'Pano şimdilik sadece bakmak için. İşaretlemek birazdan yine olacak.',
        agenda: 'Takvim',
        tasks: 'Görevler',
        rewards: 'Ödüller',
        nothingToday: 'Bugün plan yok',
        nothingMore: 'Bugün başka bir şey yok',
        noTasks: 'Bugün görev yok',
        allDone: 'Hepsi bitti!',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'Her şey tamam',
        allDay: 'Tüm gün',
        everyone: 'Herkes',
        next: 'Sırada',
        startsIn: '{time} sonra',
        busyFor: '{time} kaldı',
        minutesShort: '{count} dk',
        hoursShort: '{h} sa {m} dk',
        tasksProgress: '{done}/{total} bitti',
        pairTitle: 'Bu tableti bağla',
        pairHint: 'Bu kodu telefonuna gir:',
        pairScan: 'Ya da QR kodunu telefonunla tara',
        pairWaiting: 'Onay bekleniyor…',
        pairStarting: 'Kod alınıyor…',
        pairExpired: 'Kodun süresi doldu, yeni kod alınıyor…',
        pairNoConnection: 'Sunucuya bağlantı yok, tekrar deneniyor…',
        pairQrClaiming: 'QR koduyla bağlanıyor…',
        pairQrInvalid: 'Bu QR kodunun süresi doldu ya da kullanıldı. Ebeveyn uygulamasında yenisini oluşturun ya da bu ekrandaki kodla bağlayın.',
        pairQrLimit: 'Aboneliğinize başka tablet eklenemiyor. Önce ebeveyn uygulamasında başka bir tabletin bağlantısını kaldırın.',
        pairQrBusy: 'Biraz fazla deneme oldu. Bir dakika bekleyin, sonra QR kodunu tekrar tarayın.',
        pairQrOffline: 'Bağlantı yok, bu yüzden QR kodu çalışmadı. Tekrar tarayın ya da bu ekrandaki kodla bağlayın.',
        offline: 'Bağlantı yok, son durum: {time}',
        offlineBadge: 'Bağlantı yok',
        renderFailed: 'Pano takvimi şu an gösteremiyor, tekrar deniyor.',
        checkInApp: 'Bu tableti ebeveyn uygulamasında kontrol et',
        staleData: 'Güncel bilgi yok',
        standaloneTitle: 'Aile panosunu ana ekrana ekle',
        standaloneBody: 'Safari’de Paylaş’a, sonra "Ana Ekrana Ekle"ye dokun. Panoyu bundan sonra o simgeden aç, yoksa bağlantı saklanmaz.',
        points: { one: '{count} puan', other: '{count} puan' },
        tasksLeft: { one: '{count} görev kaldı', other: '{count} görev kaldı' },
    },
    web: {
        // 0035: gepauzeerd door AMUMIN Beheer (423 household_paused).
        householdPaused: 'Aile panonuz şimdilik sadece görüntüleme modunda. Değişiklik yapılamaz.',
        appName: 'AMUMIN Family Board',
        loginTitle: 'Giriş yap',
        email: 'E-posta adresi',
        password: 'Şifre',
        login: 'Giriş yap',
        forgotPassword: 'Şifreni mi unuttun?',
        noAccount: 'Henüz hesabın yok mu?',
        register: 'Hesap oluştur',
        save: 'Kaydet',
        add: 'Ekle',
        edit: 'Düzenle',
        remove: 'Sil',
        loading: 'Yükleniyor…',
        retry: 'Tekrar dene',
        close: 'Kapat',
        reload: 'Yeniden yükle',
        none: 'Yok',
        errorGeneric: 'Bir şeyler ters gitti. Tekrar dene.',
        errorNetwork: 'Sunucuya bağlantı yok.',
        errorNotFound: 'Bu sayfa yok.',
        moduleOff: 'Bu bölüm ailen için kapalı.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: '16 yaşında veya daha büyük biri buna kendisi izin verir. Üyeler bölümünde yaşları kontrol edin ve tekrar deneyin.',
        versionConflict: 'Bu arada başka biri bunu değiştirdi. Liste yeniden yüklendi; bir kez daha dene.',
        rateLimited: 'Çok fazla deneme. {seconds} saniye sonra tekrar dene.',
        sessionExpired: 'Oturumun sona erdi. Yeniden giriş yap.',
        nav: {
            today: 'Bugün',
            agenda: 'Takvim',
            members: 'Üyeler',
            devices: 'Cihazlar',
            security: 'Güvenlik',
            household: 'Aile',
            logout: 'Çıkış yap',
        },
        timeInAmsterdam: 'Amsterdam saati',
        browserZoneDiffers: 'Tarayıcın başka bir saat diliminde; buradaki tüm saatler Amsterdam saatine göre.',
        householdSwitch: 'Etkin aile',
        sharedComputer: 'Ortak ya da herkese açık bilgisayar',
        sharedComputerHint: 'Oturumun 24 saat sonra biter ve bu tarayıcıya güvenilmez.',
        stayLoggedIn: 'Oturumum açık kalsın',
        invalidCredentials: 'E-posta adresi ya da şifre yanlış.',
        emailNotVerified: 'Önce e-postadaki bağlantıyla e-posta adresini onayla.',
        outsideTrustedNetwork: 'Güvenilir bir ağın dışındasın. Şifren ve bir e-posta koduyla yeniden giriş yap.',
        forgetToLogout: 'İşin bitince çıkış yapmayı unutma.',
        lockedOut: 'Çok fazla başarısız deneme. Daha sonra tekrar dene.',
        codeTitle: 'E-posta kodu',
        codeIntro: '6 haneli bir kodu şu adrese gönderdik: {email}. Kod 10 dakika geçerli.',
        codeLabel: 'E-postadaki kod',
        codeInvalid: 'E-postadaki 6 rakamı gir.',
        codeWrong: 'Bu kod yanlış. {count} deneme hakkın kaldı.',
        codeWrongPlain: 'Bu kod yanlış.',
        codeLocked: 'Çok fazla yanlış kod. Yeni bir kod almak için yeniden giriş yap.',
        codeExpired: 'Kodun süresi doldu. Yeni bir kod almak için yeniden giriş yap.',
        trustBrowser: 'Bu tarayıcıya 30 gün güven',
        trustBrowserHint: '{date} tarihine kadar bu tarayıcıda e-posta kodu istemeyeceğiz.',
        resend: 'Kodu yeniden gönder',
        resendIn: '{seconds} sn sonra yeniden gönderebilirsin',
        resent: 'Yeni kod gönderildi; önceki kod artık geçersiz.',
        notMeLink: 'Bu ben değildim',
        noPendingCode: 'Bekleyen bir giriş denemesi yok. Önce giriş yap.',
        networkConfirmIntro: 'Yeni güvenilir ağı, {email} adresine gönderdiğimiz 6 haneli kodla onayla.',
        registerTitle: 'Hesap oluştur',
        passwordHint: 'En az 12 karakter.',
        passwordTooShort: 'En az 12 karakter kullan.',
        passwordTooLong: 'En fazla 256 karakter kullan.',
        emailInvalid: 'E-posta adresini kontrol et.',
        passwordRepeat: 'Şifreyi tekrarla',
        passwordMismatch: 'Şifreler aynı değil.',
        registerDone: 'E-postanı kontrol et',
        registerDoneText: '{email} adresine bir onay bağlantısı gönderdik. Hesabını etkinleştirmek için bağlantıya tıkla.',
        alreadyAccount: 'Zaten hesabın var mı?',
        emailTaken: 'Bu e-posta adresiyle zaten bir hesap var.',
        passwordBreached: 'Bu şifre bir veri sızıntısında geçiyor. Başka bir şifre seç.',
        privateEmailHint: 'İpucu: iş adresini değil, kişisel bir e-posta adresi kullan.',
        verifyTitle: 'E-posta adresini onayla',
        verifyIntro: 'E-posta adresini onaylamak için düğmeye tıkla.',
        verifyButton: 'Onayla',
        verifying: 'Onaylanıyor…',
        verifyDone: 'E-posta adresin onaylandı. Artık giriş yapabilirsin.',
        verifyInvalid: 'Bu bağlantı geçersiz ya da süresi dolmuş.',
        tokenMissing: 'Bu bağlantı eksik. E-postadaki bağlantıyı yeniden aç.',
        toLogin: 'Girişe git',
        resetTitle: 'Şifremi unuttum',
        resetIntro: 'E-posta adresini yaz. Bir hesap varsa şifreni değiştirmen için bir bağlantı göndeririz (60 dakika geçerli).',
        resetSend: 'Bağlantı gönder',
        resetSent: '{email} adresiyle bir hesap varsa bir e-posta yolda.',
        resetConfirmTitle: 'Yeni şifre',
        newPassword: 'Yeni şifre',
        resetConfirmButton: 'Şifreyi değiştir',
        resetDone: 'Şifren değiştirildi. Tüm güvenilir tarayıcılar unutuldu; bir sonraki girişte yeniden e-posta kodu isteyeceğiz.',
        resetInvalid: 'Bu sıfırlama bağlantısı geçersiz ya da süresi dolmuş.',
        notMeTitle: 'Bu ben değildim',
        notMeIntro: 'Biri senin şifrenle giriş yapmaya çalıştı. Bu sen değil miydin? O zaman hesabını kilitleriz.',
        notMeWhatHappens: 'Düğmeye bastığında olacaklar:',
        notMeStep1: 'Bekleyen giriş denemesi engellenir.',
        notMeStep2: {
            one: '{count} güvenilir tarayıcı unutulur.',
            other: '{count} güvenilir tarayıcı unutulur.',
        },
        notMeStep2Unknown: 'Tüm güvenilir tarayıcılar unutulur.',
        notMeStep3: {
            one: 'Bekleyen {count} giriş kodu geçersiz olur.',
            other: 'Bekleyen {count} giriş kodu geçersiz olur.',
        },
        notMeStep4: 'Yeni bir şifre seçmen için bir e-posta alırsın.',
        notMeButton: 'Evet, bu ben değildim',
        notMeDone: 'Tamam. Yeni bir şifre seçme bağlantısı için e-postanı kontrol et.',
        notMeInvalid: 'Bu bağlantı geçersiz ya da zaten kullanılmış.',
        stepUpTitle: 'Şifrenle onayla',
        stepUpIntro: 'Bu işlem için evde bile şifreni yeniden soruyoruz. Bu 10 dakika geçerli.',
        stepUpButton: 'Onayla',
        stepUpWrong: 'Şifre yanlış.',
        stepUpCancelled: 'İşlem iptal edildi.',
        wizardTitle: 'Aileni ayarla',
        wizardIntro: 'Başlamak için birkaç şey; her şey sonra değiştirilebilir.',
        wizardHouseholdName: 'Ailenin adı',
        wizardHouseholdHint: 'Panonun en üstünde görünür, örneğin "Yılmaz Ailesi".',
        wizardYou: 'Panodaki adın',
        wizardPinTitle: 'Ebeveyn PIN’i',
        wizardPinPlaceholder: 'Yakında: tabletteki ebeveyn modu için PIN’i burada şifre onayıyla belirleyeceksin.',
        wizardInviteTitle: 'İkinci ebeveyni davet et',
        wizardInvitePlaceholder: 'Yakında: e-postayla davet; diğer ebeveyn bu ailede aynı yetkileri alır.',
        wizardTrustTitle: 'Bu ağa güven',
        wizardTrustHint: 'Güvenlik bölümünden ayarlarsın: o zaman evde e-posta kodu istemeyiz.',
        wizardSaved: 'Aile kaydedildi.',
        householdNameRequired: 'Bir ad yaz.',
        todayTitle: 'Bugün',
        todayEmpty: 'Bugün plan yok.',
        tasksTitle: 'Görevler',
        tasksEmpty: 'Bugün görev yok.',
        allDay: 'Tüm gün',
        everyone: 'Herkes',
        doneBy: 'Bitti',
        quickAdd: 'Hızlı ekle',
        agendaTitle: 'Takvim',
        newEvent: 'Hızlı etkinlik',
        newTask: 'Hızlı görev',
        title: 'Başlık',
        date: 'Tarih',
        start: 'Başlangıç',
        duration: 'Süre (dakika)',
        forWhom: 'Kimin için',
        allDayLabel: 'Tüm gün',
        icon: 'Simge',
        iconNone: 'Simge yok',
        location: 'Yer',
        createEvent: 'Etkinlik ekle',
        createTask: 'Görev ekle',
        eventCreated: 'Etkinlik eklendi.',
        taskCreated: 'Görev eklendi.',
        titleRequired: 'Bir başlık yaz.',
        titleTooLong: 'En fazla 120 karakter.',
        dateInvalid: 'Geçerli bir tarih seç (YYYY-AA-GG).',
        memberRequired: 'En az bir kişi seç.',
        startInvalid: 'Bir başlangıç saati seç (SS:DD).',
        durationInvalid: 'Süre en az 5, en fazla 1440 dakika.',
        listFor: '{date} takvimi',
        showDay: 'Göster',
        deleteEvent: 'Etkinliği sil',
        deleteTask: 'Görevi sil',
        itemDeleted: 'Silindi.',
        noEventsDay: 'Bu gün etkinlik yok.',
        noTasksDay: 'Bu gün görev yok.',
        membersTitle: 'Üyeler',
        membersIntro: 'Panoda görünen herkes, hesabı olsun ya da olmasın.',
        addMember: 'Üye ekle',
        editMember: 'Üyeyi düzenle',
        memberName: 'Ad',
        memberKind: 'Tür',
        kindAdult: 'Yetişkin',
        kindChild: 'Çocuk',
        kindHelper: 'Yardımcı',
        color: 'Renk',
        avatarIcon: 'Avatar simgesi',
        ageBand: 'Yaş grubu',
        ageBandNone: 'Belirtilmedi',
        nameRequired: 'Bir ad yaz.',
        nameTooLong: 'En fazla 40 karakter.',
        memberSaved: 'Üye kaydedildi.',
        colorNames: {
            orange: 'Turuncu',
            skyblue: 'Gök mavisi',
            bluishgreen: 'Mavi-yeşil',
            yellow: 'Sarı',
            blue: 'Mavi',
            vermillion: 'Kiremit kırmızısı',
            reddishpurple: 'Kırmızı-mor',
            black: 'Siyah',
        },
        devicesTitle: 'Cihazlar',
        devicesEmpty: 'Henüz bağlı tablet yok.',
        pairDevice: 'Bağla',
        deviceName: 'Ad',
        room: 'Oda',
        status: 'Durum',
        lastSeen: 'Son görülme',
        lastSync: 'Son eşitleme',
        statusActive: 'Etkin',
        statusRevoked: 'Bağlantısı kesildi',
        statusSuspect: 'Şüpheli',
        online: 'Çevrimiçi',
        offline: 'Çevrimdışı',
        never: 'Hiç',
        justNow: 'az önce',
        minutesAgo: { one: '{count} dakika önce', other: '{count} dakika önce' },
        hoursAgo: { one: '{count} saat önce', other: '{count} saat önce' },
        daysAgo: { one: '{count} gün önce', other: '{count} gün önce' },
        rename: 'Yeniden adlandır',
        revoke: 'Bağlantıyı kes',
        revokeConfirm: '"{name}" cihazının bağlantısını kesmek istediğine emin misin? Tablet bir dakika içinde bağlantı ekranını gösterir.',
        revokeYes: 'Evet, bağlantıyı kes',
        deviceRevoked: 'Cihazın bağlantısı kesildi.',
        deviceSaved: 'Cihaz kaydedildi.',
        appVersion: 'Sürüm',
        standalone: 'Ana ekran uygulaması',
        swState: 'Service worker',
        storageOk: 'Depolama',
        clockOffset: 'Saat farkı',
        pairTitle: 'Tablet bağla',
        pairIntro: 'Tabletin gösterdiği kodu gir.',
        pairCode: 'Kod',
        pairReviewIntro: 'Tabletinizdeki kodu kontrol edin, ardından adını ve odasını seçin.',
        pairConnect: 'Bu tableti bağla',
        pairMatch: 'Bu kod tabletinizdeki kodla aynı mı?',
        pairChangeCode: 'Başka bir kod gir',
        pairDetails: 'Cihaz bilgileri',
        pairNameLabel: 'Tabletin adı',
        pairNameHint: 'Bu adı daha sonra değiştirebilirsiniz.',
        pairNext: 'Tabletinize dönün. Pano orada otomatik olarak açılacak.',
        pairCodeInvalid: 'Kod 8 karakterden oluşur, örneğin 1234-5678.',
        pairLookup: 'Kodu kontrol et',
        pairNotFound: 'Bilinmeyen ya da süresi dolmuş kod. Tabletteki kodu kontrol et.',
        pairTooMany: 'Bu oturumda çok fazla yanlış kod. Yeniden giriş yap.',
        pairUserAgent: 'Tarayıcı',
        pairPlatform: 'Platform',
        pairCountry: 'Ülke',
        pairStarted: 'Başlatıldı',
        pairUnknown: 'bilinmiyor',
        pairApprove: 'Onayla',
        pairApproved: '"{name}" tableti bağlandı. Pano birkaç saniye içinde görünür.',
        roomRequired: 'Bir oda seç.',
        toDevices: 'Cihazlara git',
        securityTitle: 'Güvenlik',
        trustedNetworksTitle: 'Güvenilir ağlar',
        trustedNetworksIntro: 'Güvenilir bir ağda e-posta kodu istemeyiz; şifren her zaman gerekli.',
        trustThisNetwork: 'Bu ağa güven',
        trustServerWan: 'Sunucunun internet adresine güven',
        currentPrefix: 'Şu an bağlı olduğun ağ: {prefix}',
        serverWanLabel: 'Sunucunun internet adresi: {ip}',
        currentPrefixUnknown: 'İnternet adresin bilinmiyor.',
        networkNoSuggestion: 'Bu ağ güvenilir ağ olarak eklenemez (örneğin yerel bir ağ ya da paylaşılan bir sağlayıcı ağı).',
        networkAlreadyTrusted: 'Bu ağa zaten güveniliyor.',
        addNetwork: 'Ağ ekle',
        label: 'Etiket',
        labelRequired: 'Bir etiket yaz.',
        kind: 'Tür',
        kindCidr: 'Ağ (CIDR, örn. 192.168.1.0/24)',
        kindIp: 'Tek adres (IPv4)',
        kindServerWan: 'Sunucunun internet adresi (kendiliğinden güncellenir)',
        kindDdns: 'DDNS ana bilgisayar adı',
        value: 'Değer',
        valueInvalid: 'Bu ağ türü için geçersiz değer.',
        valueIpv6: 'IPv6 henüz desteklenmiyor.',
        valueCgnat: 'Bu adres paylaşılan bir sağlayıcı ağına (CGNAT) ait, güvenilir yapılamaz.',
        scope: 'Kimin için geçerli',
        scopeHousehold: 'Tüm aile',
        scopeIdentity: 'Sadece ben',
        rememberDefault: 'Bu ağda "Oturumum açık kalsın" varsayılan olarak açık',
        officeWarning: 'Bu adresin arkasındaki herkes e-posta kontrolünü atlar. Bu sabit bir iş yeri adresi mi?',
        mobileHint: 'Mobil veri ya da 4G mi kullanıyorsun? O zaman girişte "Bu tarayıcıya 30 gün güven" seçeneğini tercih et.',
        networkCreated: 'Ağ eklendi. E-posta koduyla onayla.',
        networkConfirmed: 'Ağ onaylandı. Bu ağda artık e-posta kodu istemeyiz.',
        unconfirmed: 'Henüz onaylanmadı',
        confirmedAt: 'Onaylandı',
        lastMatched: 'Son eşleşme',
        disabledLabel: 'Kapalı',
        enabledLabel: 'Açık',
        disable: 'Kapat',
        enable: 'Aç',
        thisNetwork: 'bu ağ',
        noNetworks: 'Henüz güvenilir ağ yok.',
        trustedBrowsersTitle: 'Güvenilir tarayıcılar',
        trustedBrowsersIntro: 'Şifre ve e-posta kodundan sonra bir tarayıcıya 30 gün güveniriz; sonra yeniden kod isteriz.',
        thisBrowser: 'Bu tarayıcı',
        issued: 'Verildi',
        trustedUntil: '{date} tarihine kadar güvenilir',
        lastUsedAt: 'son kullanım {when}',
        expiresOn: 'bitiş {date}',
        todayAt: 'bugün {time}',
        yesterdayAt: 'dün {time}',
        expires: 'Bitiş',
        lastUsed: 'Son kullanım',
        forget: 'Unut',
        forgetOthers: 'Diğer tüm tarayıcıları unut',
        noTrustedBrowsers: 'Güvenilir tarayıcı yok.',
        browserForgotten: 'Tarayıcı unutuldu.',
        sessionsTitle: 'Oturumlar',
        routeLabel: 'Yol',
        routeBrowser: 'güvenilir tarayıcı',
        routeNetwork: 'güvenilir ağ',
        routeOnce: 'tek seferlik (24 saat)',
        routeNone: 'yok',
        thisSession: 'Bu oturum',
        revokeSession: 'Sonlandır',
        logoutEverywhere: 'Her yerden çıkış yap',
        logoutForget: 'Çıkış yap ve bu tarayıcıyı unut',
        sessionRevoked: 'Oturum sonlandırıldı.',
    },
};
//# sourceMappingURL=tr.js.map